import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "./wedding/LanguageContext";
import useSmoothScroll from "./wedding/useSmoothScroll";
import Curtain from "./wedding/Curtain";
import MusicToggle from "./wedding/MusicToggle";
import Header from "./wedding/Header";
import Hero from "./wedding/Hero";
import Ribbon from "./wedding/Ribbon";
import QuoteSection from "./wedding/QuoteSection";
import Countdown from "./wedding/Countdown";
import LocationSection from "./wedding/LocationSection";
import TravelSection from "./wedding/TravelSection";
import Guestbook from "./wedding/Guestbook";
import KinaSection from "./wedding/KinaSection";
import Footer from "./wedding/Footer";
import Overzicht from "./wedding/Overzicht";

function WeddingSite() {
  useSmoothScroll();
  return (
    <LanguageProvider>
      <div className="App grain min-h-screen bg-cream text-ink antialiased">
        <Curtain />
        <Header />
        <MusicToggle />
        <main>
          <Hero />
          <Ribbon direction="left" color="ink" />
          <QuoteSection />
          <Countdown />
          <LocationSection />
          <TravelSection />
          <Ribbon direction="right" color="ink" />
          <Guestbook />
        </main>
        <KinaSection />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

function App() {
  const path = window.location.pathname.replace(/\/+$/, "");
  const isAdmin = path === "/overzicht";

  return (
    <>
      {isAdmin ? <Overzicht /> : <WeddingSite />}
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A1F28",
            color: "#FDFBF7",
            border: "1px solid rgba(197,160,89,0.5)",
            borderRadius: "999px",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </>
  );
}

export default App;
